import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {HttpService} from '../http-service/http.service';
import {Utils} from '../../../../core/helpers/Utils';
import {ResourceModel} from '../../../../core/models/resources/resource.model';
import {Const, ResourceState, ResourceType} from '../../../../core/helpers/Const';
import {CrudService} from '../crud/crud.service';
import {ServiceModule} from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export abstract class ResourceService<T extends ResourceModel> extends CrudService<T> {
    protected constructor(protected override httpService: HttpService<T>) {
        super(httpService);
    }

    override getList(path = ''): Observable<T[]> {
        return super.getList(path).pipe(map((data) => data.map((i) => this.enrichItem(i, true))));
    }

    getServices(path = ''): Observable<T> {
        return super.get(path);
    }

    override get(id: string | number, query = ""): Observable<T> {
        return super.get(id, query).pipe(map((data) => this.enrichItem(data, true)));
    }

    override add(path: string, id: string | number, resource: T): Observable<T> {
        return super.add(path, id, resource).pipe(map((data) => this.enrichItem(data, false)));
    }

    override delete(path: string, id: string | number, query = ""): Observable<T> {
        return super.delete(path, id, query);
    }

    override update(path: string, id: string | number, resource: T): Observable<T> {
        return super.update(path, id, resource).pipe(map((data) => this.enrichItem(data, false)));
    }

    touch(apiVersion: string, type: string, path: string, name: string, resource: T): Observable<T> {
        const url = `${this.APIUrl}/${apiVersion}/${type}${path}/${name}/touch`;
        return this.httpService.update(url, resource);
    }

    touchByPath(path: string, name: string, resource: T): Observable<T> {
        const url = `${this.APIUrl}${path}/${name}/touch`;
        return this.httpService.update(url, resource);
    }

    move(apiVersion: string, type: string, path: string, name: string, resource: T): Observable<T> {
        const url = `${this.APIUrl}/${apiVersion}/${type}${path}/${name}/.move`;
        return this.httpService.post(url, resource).pipe(map((data) => this.enrichItem(data, false)));
    }

    getMoveStatus(operationID: string): Observable<T> {
        const url = `${this.APIUrl}/move/${operationID}`;
        return this.httpService.get(url);
    }

    enrichItem(resourceModel: T, setUnknown: boolean) {
        resourceModel.state = Utils.getState(resourceModel, setUnknown);
        if (Const.IMMEDIATELY_READY_RESOURCE_TYPES.includes(resourceModel.type)) {
            resourceModel.state = ResourceState.READY;
        }
        if (!resourceModel.displayName) {
            resourceModel.displayName = resourceModel.name;
        }
        return resourceModel;
    }
}
